import { Button } from "@mantine/core";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import useAuthStore from "../../../store/useAuthStore";
import NavbarItem from "./NavbarItem";

export default function NavbarSection({ title, url, permission: itemPermission, icon, children, close, badge }) {
  const permission = useAuthStore((state) => state.permission);
  const user = useAuthStore((state) => state.user);

  function handleClick() {
    close();
    window.scrollTo(0, 0);
  }

  if (itemPermission && !itemPermission?.includes(permission)) return null;
  if (user?.id === 98 && url === "/invoice") return null;

  if (children?.length > 0) {
    return <NavbarItem title={title} isActive={false} icon={icon} list={children} badge={badge} />;
  }

  return (
    <NavLink to={url} end onClick={handleClick}>
      {({ isActive }) => <NavbarItem title={title} isActive={isActive} icon={icon} list={false} badge={badge} />}
    </NavLink>
  );
}
